// Admin "Doctors" page (/medical/doctors): the medical incharge's Doctors
// screen (DoctorBank - Doctors / Hospitals / Diagnostic Centers, as shown by
// MedicalInchargeDashboard.js) under the admin's own top menu. Every other
// role still gets the older DoctorsDataBank at this route.
import React, { useRef } from 'react';
import DoctorBank from '../medical/DoctorBank';
import useFixedHeaderOverlap from '../../components/adminDailySchedule/useFixedHeaderOverlap';

export default function AdminDoctorsPage() {
    const pageRef = useRef(null);
    const headerOverlap = useFixedHeaderOverlap(pageRef);

    return (
        <div ref={pageRef} className="adm-doctors-page" style={{ paddingTop: 16 + headerOverlap }}>
            <DoctorBank embedded />
        </div>
    );
}
